
<template>

	<b-modal :id="id" size="xl" @show="reset" @hidden="reset" title="Множественное редактирование. Сброс значений характеристики / ценообразующего фактора" @ok="ok" ok-title="Применить" cancel-title="Отменить" cancel-variant="outline-primary-secondary" no-close-on-backdrop>

		<form @submit.stop.prevent="submit">

			<attr_select v-model="attr_key" :attrs="attrs"/>

		</form>

	</b-modal>

</template>

<script>

import { uuid } from "vue-uuid"
import api from "../../../api"
import attr_select from "./select"

export default
{
	props :
	{
		service : String,
		attrs : Array,
	},

	components :
	{
		attr_select
	},

	data()
	{
		return {
			
			id : uuid.v1(),

			attr_key : null,

		}
	},

	methods :
	{
		reset()
		{
			this.attr_key = null
		},

		execute()
		{
			this.$bvModal.show(this.id)
		},

		ok(event)
		{
			event.preventDefault()
			this.submit()
		},

		submit()
		{
			const params = {
				
				field : this.attr_key,
				query : this.$parent.get_query(),

			}

			api.call(this, this.$props.service, "unset_field_many", params,
				() =>
				{
					this.$emit("need_refresh")

					this.$nextTick(() => { this.$bvModal.hide(this.id, "modal-prevent-closing") })
				})
		}
	}
}

</script>

